// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Future from "reason-future/src/Future.bs.js";
import * as FutureJs from "reason-future/src/FutureJs.bs.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as SterlingModal$LiveRoom from "../bindings/SterlingModal.bs.js";
import * as Utils_Logging$LiveRoom from "../Utils/Utils_Logging.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function RefetchModalContent(props) {
  var title = props.title;
  var refetch = props.refetch;
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement(SterlingModal$LiveRoom.Content.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: Css.margin(Css.px(24)),
                    tl: /* [] */0
                  })
            }, React.createElement(SterlingTypography$LiveRoom.Paragraph18Regular.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.marginBottom(Css.px(16)),
                        tl: /* [] */0
                      }),
                  children: Curry._2(match.t2, "Modal_ErrorLoading", {
                        title: title
                      })
                }), React.createElement(Button.Button, {
                  onClick: (function (param) {
                      Future.tapError(FutureJs.fromPromise(Curry._1(refetch, undefined), (function (param) {
                                  return {
                                          NAME: "UnknownError",
                                          VAL: "Unknown server error"
                                        };
                                })), (function (param) {
                              Utils_Logging$LiveRoom.log(undefined, undefined, undefined, "Refetch " + title + " modal data: failure!");
                            }));
                    }),
                  buttonStyle: "primaryNavy",
                  children: Curry._1(match.t, "Retry")
                }));
}

var make = RefetchModalContent;

export {
  make ,
}
/* Css Not a pure module */
